import React from 'react';

const DropdownButton = ({ children, onClick, type = "button", className = "", icon, transparent, ...props }) => {
    return (
        <button
            type={type}
            onClick={onClick}
            className={`
                flex items-center justify-center gap-2
                px-4 py-2 rounded-[500px]
                ${transparent ? 
                    'bg-transparent border border-white text-white hover:bg-[#05897e] hover:text-white' : 
                    'bg-white border border-white text-black hover:bg-[#05897e] hover:border-[#05897e] hover:text-white'}
                
                body-medium
                transition-colors duration-200
                ${className}
            `}
            {...props}
        >
            {children}
            {icon || (
                <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M5.83301 8.33337L9.99967 12.5L14.1663 8.33337"
                        stroke="currentColor"
                        strokeWidth="1.125"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            )}
        </button>
    );
};

export default DropdownButton;
